import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import ProductPage from "../views/ProductPage.vue";
import News from "../views/News.vue";
import Jobs from "../views/Jobs.vue";
import Cooperation from "../views/Cooperation.vue";
import TechnologyPage from "../views/TechnologyPage.vue";
import ProfilePage from "../views/ProfilePage.vue";
import CooperationCasesPage from "../views/CooperationCasesPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/technology",
    name: "Technology",
    component: TechnologyPage,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/product/:id",
    name: "ProductPage",
    component: ProductPage,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/join",
    name: "Jobs",
    component: Jobs,
  },
  {
    path: "/cooperation",
    name: "Cooperation",
    component: Cooperation,
  },
  ,
  {
    path: "/cooperationCases",
    name: "CooperationCases",
    component: CooperationCasesPage,
  },
  // 后台管理路由组
  {
    path: "/admin",
    component: () => import("../views/layouts/AdminLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "products",
        name: "ProductManagement",
        component: () => import("../views/admin/ProductManagement.vue"),
      },
      {
        path: "news",
        name: "NewsManagement",
        component: () => import("../views/admin/NewsManagement.vue"),
      },
      {
        path: "jobs",
        name: "JobManagement",
        component: () => import("../views/admin/JobManagement.vue"),
      },
      {
        path: "job-applications",
        name: "JobApplicationManagement",
        component: () => import("../views/admin/JobApplicationManagement.vue"),
      },
      {
        path: "cooperation",
        name: "CooperationManagement",
        component: () => import("../views/admin/CooperationManagement.vue"),
      },
      {
        path: "banners",
        name: "BannerManagement",
        component: () => import("../views/admin/BannerManagement.vue"),
      },
      {
        path: "cooperation-cases",
        name: "CooperationCaseManagement",
        component: () => import("../views/admin/CooperationCaseManagement.vue"),
      },
      {
        path: "contact-info",
        name: "ContactInfoManagement",
        component: () => import("../views/admin/ContactInfoManagement.vue"),
      },
    ],
  },
];

const router = createRouter({
  mode: "hash",
  base: "/",
  history: createWebHashHistory(),
  routes,
});

// 导航守卫
router.beforeEach((to, from, next) => {
  // 检查路由是否需要认证
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 检查是否存在token
    const token = localStorage.getItem("token");
    if (!token) {
      // 没有token，重定向到登录页面
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      // 有token，继续导航
      next();
    }
  } else {
    // 不需要认证的路由，直接通过
    next();
  }
});

export default router;
